import type {
	MembershipListResponse,
	TicketCommentDTO,
} from "@zplanem/responses"
import type { MentionCandidate } from "../../../components/chat/use-mention-compose"
import { buildTicketMentionCandidates } from "./ticket-form-model"

export function canDeleteTicketComment(
	comment: TicketCommentDTO,
	viewerId: string | undefined,
	canManageTickets: boolean,
): boolean {
	if (canManageTickets) return true
	return viewerId != null && comment.author?.id === viewerId
}

export function canEditTicketComment(
	comment: TicketCommentDTO,
	viewerId: string | undefined,
): boolean {
	return viewerId != null && comment.author?.id === viewerId
}

export function buildTicketCommentMentionCandidates(
	memberships: MembershipListResponse | undefined,
	viewerId: string | undefined,
): MentionCandidate[] {
	return buildTicketMentionCandidates(memberships, viewerId)
}
